import * as React from 'react';
import { pure } from 'recompose';
import { Flex } from 'grid-styled';

/* Style */
import './AddToCartButton.scss';
/* Utils */

interface AddToCartButtonProps {
  containerWidth: number;
  onClick: () => void;
  htmlLabel: string;
  color: string;
  borderColor: string;
  backgroundColor: string;
}

class AddToCartButton extends React.Component<AddToCartButtonProps, {}> {
  getHTMLTitle = () => ({ __html: this.props.htmlLabel });

  render() {
    const {
      backgroundColor,
      borderColor,
      color,
      onClick,
      htmlLabel,
    } = this.props;
    const fontWeight = color === '#0a0a0a' ? 'bold' : 500;
    const fontSize = htmlLabel === 'SELECT FROM OPTIONS' ? 12 : 15;
    return (
      <Flex align="center" justify="center">
        <button
          onClick={onClick}
          className="AddToCartButton fs-ignore-rage-clicks"
          data-cypress="AddToCartButton"
          style={{ backgroundColor, color, borderColor, fontWeight, fontSize }}
          dangerouslySetInnerHTML={this.getHTMLTitle()}
        />
      </Flex>
    );
  }
}

export default pure(AddToCartButton);
